import { render, staticRenderFns } from "./EditAllergiesDialog.vue?vue&type=template&id=58eb7691&scoped=true"
import script from "./EditAllergiesDialog.vue?vue&type=script&lang=js"
export * from "./EditAllergiesDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAllergiesDialog.vue?vue&type=style&index=0&id=58eb7691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb7691",
  null
  
)

export default component.exports